import axios from 'axios';
import BASE_URL from '../config';

/**
 * Verify email with OTP
 * @param {string} email - User's email address
 * @param {string} otp - 6-digit OTP code
 * @returns {Promise} Response from the API
 */
export const verifyEmail = async (email, otp) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/verify-email/`, {
      email,
      otp
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Resend OTP to user's email
 * @param {string} email - User's email address
 * @returns {Promise} Response from the API
 */
export const resendOTP = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/resend-otp/`, {
      email
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
